import { render, staticRenderFns } from "./VuexDropdown.vue?vue&type=template&id=fd756c88&"
import script from "./VuexDropdown.vue?vue&type=script&lang=ts&"
export * from "./VuexDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports